export function topNavLi(drawerId, isDrawerLink, obj) {
  const { url, label, l1TextColorOverride } = obj;
  const colorAttribute = l1TextColorOverride ? `data-color="${l1TextColorOverride}"` : '"',
    urlAttribute = url || '#',
    drawerLinkAttribute = isDrawerLink ? '' : 'data-drawer-link',
    drawerAttribute = isDrawerLink ? `data-drawer="${drawerId}"` : '';

  return `<li data-drawer="${drawerId}" ${drawerLinkAttribute}>
                <a href="${urlAttribute}" data-ht-element="nav-l1-link" class="header__menu-item list-menu__item link" ${drawerAttribute}>
                    <span class="header__active-menu-item" ${colorAttribute}>${label}</span>
                </a>
            </li>`;
}

export function drawerWrapper(key, columns) {
  let drawerWrappers = '';
  for (let i = 1; i <= columns; i++) {
    drawerWrappers += `<div class="drawer-wrapper__col-${i}"></div>`;
  }
  return `<div class="drawer-wrapper page-width" data-wrapper="${key}" data-columns="${columns ? columns : 4}">
  ${drawerWrappers}
  </div>`;
}

export function level4Item(obj) {
  const { key, url, image, cta, description, imageType } = obj;
  return `<div class="level-4__item tile--${imageType}">
                <figure data-caption-id="${key}">
                    <a href="${url}" data-ht-element="nav-l4-link" data-ht-element="nav-l4-link">
                        <img src="${image}" data-src="${image}" loading="lazy" alt="${key + ' Level 4 Image'}">
                        <div>
                        <figcaption class="t4">
                            ${cta}
                            <span class="arrow"></span>
                        </figcaption>
                        ${description ? '<p class="level-4__item--description-mobile p5" data-color="night-sky-dark">' + description + '</p>' : ''}
                        </div>
                    </a>
                    ${description ? '<p class="level-4__item--description p5" data-color="night-sky-dark">' + description + '</p>' : ''}
                </figure>
            </div>`;
}

export function level3Item(obj) {
  const { key, label, url, badge, caption } = obj;
  return `<li class="level-3__item" data-caption-id="${key}|${label}" data-nav-id="${key}">

                <a href="${url}" class="link link--animated-underline p3" data-ht-element="nav-l3-link" data-caption-id="${key}|${label}" data-ht-element="nav-l3-link">
                    ${label}
                    
                </a>
                ${badge ? '<span class="label">' + badge + '</span>' : ''}
                ${caption ? '<p class="p4 level-3__item--caption" data-color="night-sky-dark">' + caption + '</p>' : ''}


                                
            </li>`;
}

export function level3ItemContainer(obj) {
  const { key, url, labelTitle } = obj;
  return `<ul class="level-3__list list--${labelTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-')}" data-nav-id="${key}"><li class="level-2__item" data-ht-element="nav-l3-header" data-caption-id="${key}|${labelTitle}" data-childgroup="${labelTitle}">
                <${url ? 'a href="' + url + '"' : 'span'} class="e2" data-caption-id="${key}|${labelTitle}">
                    ${labelTitle}
                </${url ? 'a' : 'span'})>
            </ul>`;
}

export function level2ItemContainer(key) {
  return `<ul data-nav-id="${key}" class="level-2__list"></ul>`;
}

export function level2Item(obj) {
  const { key, label, url, badge } = obj;
  return `<li class="level-2__item" data-caption-id="${key}|${label}" data-nav-id="${key}">
                <a href="${url}" class="link link--animated-underline" data-ht-element="nav-l2-link" data-caption-id="${key}|${label}" data-ht-element="nav-l2-link">
                    ${label}
                </a>${badge ? '<span class="label">' + badge + '</span>' : ''}
           </li>`;
}

export function footerLi(url, label) {
  return `<li>
                <a href="${url}" class="header__menu-item list-menu__item link link--animated-underline">
                    ${label}
                </a>
            </li>`;
}

export function nanoSlide(slide, modal_data, optin_slide, optin_text, index) {
  let slideHTML;
  if (optin_slide == index && optin_text != '') {
    slideHTML = `<div class="splide__slide offer">
                <div class="slide--text" data-slide="${index}">
                <span class="t5 text">${optin_text}</span>
              </div>
          </div>`;
  } else {
    const termsLink = `<a
                  class="p5 terms terms--link  ${slide?.terms_text ? '' : 'desktop--hide'}"
                  data-ht-element="cta"
                  data-color="white"
                  data-type="${modal_data?.type}"
                  for="${slide?.terms_link_url == '#' ? modal_data?.content : ''}"
                  href="${slide?.terms_link_url}"
                >${slide?.terms_link_text}</a>`;
    slideHTML = `<div class="splide__slide offer">
                <div class="slide--text" data-slide="${index}">
                <span class="t5 text">${slide.main_text} ${slide?.terms_text ? '' : termsLink}</span>
                <span class="p5 terms">${slide.terms_text}</span>
                ${termsLink}
              </div>
          </div>`;
  }
  return slideHTML;
}

export function exposedNavLink(label, url, index) {
  return `<a href="${url}" class="t5" data-color="night-sky-dark" data-bg-color="daybreak" data-ht-component="exposed-nav-card-${index}">${label}</a>`;
}
